import React from "react";

import { Modal, Typography } from "@packages/ds";
import { useIntl } from "react-intl";

import Button, { ButtonWrapper } from "ds/Button";

import { ModalContent } from "./PauseEnvConfirmationModal.style";

import type { Project } from "@packages/client";

type Props = {
  showConfirmationModal: boolean;
  closeModal: () => void;
  pauseEnvironment: () => void;
  project?: Project;
};

export const PauseEnvConfirmationModal = ({
  showConfirmationModal,
  closeModal,
  pauseEnvironment
}: Props) => {
  const intl = useIntl();

  const onPauseButtonClick = () => {
    pauseEnvironment();
    closeModal();
  };
  return (
    <Modal
      isOpen={showConfirmationModal}
      onOpenChange={closeModal}
      handleClose={closeModal}
      size="small"
    >
      <ModalContent>
        <Typography.Title tag="h2">
          {intl.formatMessage({
            id: "pause_production_environment.modal.title"
          })}
        </Typography.Title>
        <Typography.BodyText>
          {intl.formatMessage(
            {
              id: "pause_production_environment.modal.description"
            },
            {
              br: () => (
                <>
                  <br />
                  <br />
                </>
              )
            }
          )}
        </Typography.BodyText>
      </ModalContent>
      <ButtonWrapper justifyContent="end">
        <Button variant="secondary" analyticId="cancel" onClick={closeModal}>
          {intl.formatMessage({
            id: "cancel"
          })}
        </Button>
        <Button
          analyticId="pause_env_confirm_button"
          onClick={onPauseButtonClick}
        >
          {intl.formatMessage({
            id: "pause_env_confirm_button"
          })}
        </Button>
      </ButtonWrapper>
    </Modal>
  );
};
